module.exports = __webpack_public_path__ + "static/img/live_no_data.c679dfad.png";